'use client'

import { useEffect } from 'react'
import Script from 'next/script'

import type { IntercomCopy } from '@/lib/app-shell/copy'

const INTERCOM_APP_ID = 'v3skz9es'
const INTERCOM_SCRIPT_URL = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`

const intercomSettings = {
    app_id: INTERCOM_APP_ID,
    hide_default_launcher: true,
    custom_launcher_selector: '.intercom-launcher',
    api_base: 'https://api-iam.intercom.io',
}

function bootIntercom() {
    const intercom = (window as unknown as Record<string, unknown>).Intercom as
        | ((...args: unknown[]) => void)
        | undefined
    if (intercom) {
        intercom('boot', intercomSettings)
    }
}

/** The custom Intercom launcher, mounted from the locale layout on every page. */
export function IntercomWidget({ contactSupport }: IntercomCopy) {
    useEffect(() => {
        ;(window as unknown as Record<string, unknown>).intercomSettings = intercomSettings
        bootIntercom()
    }, [])

    return (
        <>
            <button
                type="button"
                className="intercom-launcher fixed right-5 bottom-5 z-[5] hidden h-[60px] w-[60px] cursor-pointer items-center justify-center rounded-[32px] border-none bg-[#2e3033]/30 p-0 md:flex"
                aria-label={contactSupport.text}
            >
                <svg viewBox="0 0 28 32" width="28" height="32">
                    <path
                        d="M28 32s-4.714-1.855-8.527-3.34H3.437C1.54 28.66 0 27.026 0 25.013V3.644C0 1.633 1.54 0 3.437 0h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H28V32zm-4.139-11.982a.88.88 0 00-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 00-1.29.107 1.01 1.01 0 00.098 1.348c.13.122 3.312 3.011 9.762 3.011s9.634-2.889 9.762-3.01a1.01 1.01 0 00.1-1.348z"
                        fill="#fff"
                    />
                </svg>
            </button>
            <Script src={INTERCOM_SCRIPT_URL} strategy="afterInteractive" onLoad={bootIntercom} />
        </>
    )
}
